import { render, staticRenderFns } from "./ProductListingShowScreen.vue?vue&type=template&id=2e850b4e&"
import script from "./ProductListingShowScreen.vue?vue&type=script&lang=js&"
export * from "./ProductListingShowScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports